import React, { use, useEffect, useState } from "react";
import { listeModePayement } from "../../constant/listeModePayement";
import { CardElement } from "@stripe/react-stripe-js";
import useCoupon from "../../hooks/useCoupon";
import "../../assets/css/paiements/PaymentMethodSelector.css";
import {
  isPhoneValid,
  filterPhoneInput,
  PHONE_ERROR_MESSAGE,
} from "../../utils/formaNumber";

// Méthodes de paiement pas encore disponibles côté back-office
  // const UNAVAILABLE_METHODS = ["airtel", "cb"];
 const UNAVAILABLE_METHODS = ["cb"];

const PaymentMethodSelector = ({
  paymentMethods,
  setPaymentMethods,
  formPaiement,
  setFormpaiement,
  totalAmount,
  prixFinal,
  setPrixFinal,
  isFree,
  validePhoneNumber,
  setValidePhoneNumber,
  userId,
  categorieId,
  onCouponChange,
  couponValue,
  setCouponValue,
  remise,
  setRemise,
  type = 1
}) => {
  const selectedMethod = listeModePayement.find((m) => m.id === paymentMethods);
  const [touched, setTouched] = useState(false);
  const isUnavailable = UNAVAILABLE_METHODS.includes(paymentMethods);
  const { verifierCoupon, getCouponAutoApply } = useCoupon();
  const handlePhoneChange = (e) => {
    const filtered = filterPhoneInput(e.target.value);
    setFormpaiement({
      ...formPaiement,
      paymentDetail: filtered,
    });
  };

  // ============================================================
  // COUPON
  // ============================================================

  const [couponCode, setCouponCode] = useState("");
  const [couponStatus, setCouponStatus] = useState("idle");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");

  const montantFinal = appliedCoupon
    ? appliedCoupon.nouveauTotal
    : Number(totalAmount || 0);

  useEffect(() => {
    const fetchAutoCoupon = async () => {
      if (type == 3) return; // Ne pas appliquer automatiquement le coupon pour le boost
      if (totalAmount === null || totalAmount === undefined) return;

      try {
        const res = await getCouponAutoApply({ userId, categorieId });
        const autoCoupon = res?.data?.data;

        if (autoCoupon?.nom) {
          setCouponCode(autoCoupon.nom);

          handleApplyCoupon(autoCoupon.nom);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchAutoCoupon();
  }, []);

  useEffect(() => {
    onCouponChange?.({
      coupon: appliedCoupon,
      montantFinal,
    });
    setPrixFinal(montantFinal);
  }, [appliedCoupon]);

  useEffect(() => {
    setTouched(false);
  }, [paymentMethods]);

  useEffect(() => {
    if (totalAmount === null || totalAmount === undefined) return;
    if (!couponCode.trim()) return;
    handleApplyCoupon(couponCode);
  }, [totalAmount]);

  const handleApplyCoupon = async (coupon) => {
    const nom = coupon.trim();
    if (!nom) return;

    setCouponStatus("loading");
    setCouponError("");

    try {
      const dataCoupon = {
        nom,
        userId,
        categorieId,
        montant: Number(totalAmount || 0),
      };
      const res = await verifierCoupon(dataCoupon);

      const data = res?.data;

      if (data?.valid) {
        setAppliedCoupon({
          nom: data?.coupon?.nom || nom,
          pourcentage: Number(data?.coupon?.pourcentage || 0),
          montantReduction: Number(data?.montantReduction || 0),
          nouveauTotal: Number(data?.nouveauTotal ?? totalAmount),
          usagesRestants: data?.usagesRestants ?? null, 
        });
        setCouponStatus("valid");
        setCouponValue(data?.coupon?.nom || nom);
        setRemise(Number(data?.montantReduction || 0));
      } else {
        setAppliedCoupon(null);
        setCouponStatus("invalid");
        setCouponValue("");
        setRemise(0);
        setPrixFinal(Number(totalAmount || 0));

        setCouponError(
          data?.message ||
          "Coupon invalide, expiré ou ayant atteint sa limite d'utilisation."
        );
      }
    } catch (err) {
      console.error(err);
      setCouponValue("");
      setRemise(0);
      setAppliedCoupon(null);
      setCouponStatus("invalid");
      setCouponError(
        err?.response?.data?.message ||
        "Impossible de vérifier ce coupon pour le moment.",
      );
    }
  };

  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode("");
    setCouponValue("");
    setRemise(0);
    setCouponStatus("idle");
    setCouponError("");
    setPrixFinal(Number(totalAmount || 0));
  };

  // ============================================================
  // VALIDATION NUMERO
  // ============================================================

  useEffect(() => {
    if (isFree == 1) {
      setValidePhoneNumber(true);
      return;
    }

    if (isUnavailable) {
      setValidePhoneNumber(false);
      return;
    }

    if (paymentMethods === "cb") {
      setValidePhoneNumber(true);
      return;
    }

    setValidePhoneNumber(
      selectedMethod?.methodPayment == 3
        ? true
        : isPhoneValid(formPaiement.paymentDetail),
    );
  }, [paymentMethods, formPaiement.paymentDetail, isFree, isUnavailable]);

  // useEffect(() => {
  //   if (montantFinal <= 0) {
  //     setValidePhoneNumber(true);
  //   }
  // }, [montantFinal]);

  const handleKeyDown = (e) => {
    const controlKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Home",
      "End",
    ];

    const isCtrlCombo = e.ctrlKey || e.metaKey;

    if (controlKeys.includes(e.key) || isCtrlCombo) return;

    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
      return;
    }

    const hasSelection = e.target.selectionStart !== e.target.selectionEnd;
    if (formPaiement.paymentDetail.length >= 10 && !hasSelection) {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text");
    const filtered = filterPhoneInput(pasted);
    setFormpaiement({
      ...formPaiement,
      paymentDetail: filtered,
    });
  };

  const showError = touched && !isPhoneValid(formPaiement.paymentDetail);

  return (
    <div>
      <h3 className="article_create_subtitle">Mode de paiement</h3>

      <div className="payment_instructions">
        <div className="payment_methods_flex">
          {listeModePayement.map((m) => {
            const unavailable = UNAVAILABLE_METHODS.includes(m.id);

            return (
              <div key={m.id} className="payment_group">
                <div
                  className={`payment_box ${paymentMethods === m.id ? "active" : ""
                    } ${unavailable ? "coming_soon" : ""}`}
                  onClick={() => {
                    if (isFree != 1) {
                      setPaymentMethods(m.id);
                      setFormpaiement({ ...formPaiement, paymentDetail: "" });
                    }
                  }}
                >
                  <img className="payment_image" src={m.logo} alt={m.label} />

                  {unavailable && (
                    <span className="payment_badge">Bientôt</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <div className="payment_note">
          {/* ================================================= */}
          {/* COUPON */}
          {/* ================================================= */}

          {isFree != 1 && type != 3 && (
            <div className="coupon_box">
              <div className="coupon_input_row">
                <input
                  type="text"
                  className="coupon_input"
                  placeholder="Coupon"
                  value={couponCode}
                  disabled={
                    couponStatus === "valid" || couponStatus === "loading"
                  }
                  onChange={(e) => {
                    setCouponCode(e.target.value);
                    setCouponError("");
                    if (couponStatus === "invalid") setCouponStatus("idle");
                  }}
                />

                {couponStatus === "valid" ? (
                  <button
                    type="button"
                    className="coupon_btn coupon_btn_remove"
                    onClick={handleRemoveCoupon}
                  >
                    Retirer
                  </button>
                ) : (
                  <button
                    type="button"
                    className="coupon_btn"
                    onClick={() => {
                      handleApplyCoupon(couponCode);
                    }}
                    disabled={!couponCode.trim() || couponStatus === "loading"}
                  >
                    {couponStatus === "loading"
                      ? "Vérification..."
                      : "Appliquer"}
                  </button>
                )}
              </div>

              {couponStatus === "invalid" && couponError && (
                <p className="coupon_error">{couponError}</p>
              )}

              {couponStatus === "valid" && appliedCoupon && (
                <p className="coupon_success">
                  Coupon "{appliedCoupon.nom}" appliqué :
                  {appliedCoupon.pourcentage}% (-
                  {appliedCoupon.montantReduction.toLocaleString()} MGA)
                </p>
              )}
            </div>
          )}

          <div className="payment_summary">
            <div className="content_total_a_payer">
              <span>Sous-total</span>
              <span>{Number(totalAmount || 0).toLocaleString()} MGA</span>
            </div>

            {appliedCoupon && (
              <div className="content_reduction">
                <span>Réduction ({appliedCoupon.pourcentage}%)</span>
                <span>
                  -{appliedCoupon.montantReduction.toLocaleString()} MGA
                </span>
              </div>
            )}

            <div className="content_total_a_payer content_total_final">
              <span>Total à payer</span>
              <span>{Number(montantFinal || 0).toLocaleString()} MGA</span>
            </div>
          </div>

          {paymentMethods && (
            <div className="content_form_paiement">
              {isFree == 1 ? (
                <div className="free_payment_note">
                  <p className="free_payment_text text-center">
                    Publication gratuite jusqu'au{" "}
                    {process.env.REACT_APP_FREE_UNTIL} pour tous les
                    utilisateurs ! Profitez-en
                  </p>
                </div>
              ) : isUnavailable ? (
                <div className="payment_unavailable_note">
                  <svg
                    className="payment_unavailable_icon"
                    viewBox="0 0 24 24"
                    width="22"
                    height="22"
                    fill="none"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M12 7.5v5.5"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />
                    <circle cx="12" cy="16.3" r="1" fill="currentColor" />
                  </svg>

                  <div className="payment_unavailable_text_wrap">
                    <p className="payment_unavailable_title">
                      {selectedMethod?.label} arrive bientôt
                    </p>
                    <p className="payment_unavailable_text">
                      Ce mode de paiement n'est pas encore disponible. Merci de
                      choisir un autre moyen de paiement pour continuer.
                    </p>
                  </div>
                </div>
              ) : (
                <>
                  {paymentMethods === "cb" ? (
                    <CardElement />
                  ) : (
                    <>
                      <label>{selectedMethod?.label}</label>
                      <input
                        type="tel"
                        className="payment_input"
                        inputMode="numeric"
                        value={formPaiement.paymentDetail}
                        onChange={handlePhoneChange}
                        onKeyDown={handleKeyDown}
                        onPaste={handlePaste}
                        onBlur={() => setTouched(true)}
                        placeholder="03xxxxxxxx"
                        maxLength={10}
                      />
                      {showError && (
                        <p style={{ color: "red", fontSize: "0.85rem" }}>
                          {PHONE_ERROR_MESSAGE}
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodSelector;
